import {proxyApiMnemo} from './common';
import { mnemoService } from 'libs/api';

export const tfaIndireExamService = {    

    async myExamReservation(registrationCode, examType){
        const payload = mnemoService.buildPayloadObject('myExamReservation', {'registrationCode': registrationCode, 'examType' : examType});
        return await proxyApiMnemo.get('tfaIndire/?payload='+encodeURI(payload));        
    }

}